import { useModalDialog } from '@xemplo/modal-dialog';

import { CreateAmendmentProps } from './create-amendment.types';
import { CreateAmendmentButton } from './create-amendment-button';
import { CreateAmendmentModal } from './create-amendment-modal';
import { useCreateAmendment } from './use-create-amendment';

export function CreateAmendment(props: Readonly<CreateAmendmentProps>) {
  const { renderButton, buttonProps, buttonChildren } = props;

  const modalDialog = useModalDialog({ id: 'create-amendment-modal' });

  const {
    handleClose,
    methods,
    getFormStep,
    primaryButton,
    tertiaryButton,
    confirmationPrompt,
    showButton,
  } = useCreateAmendment({ ...props, modalDialog });

  return (
    <>
      <CreateAmendmentButton
        show={showButton}
        onClick={() => modalDialog.openModalDialog()}
        renderButton={renderButton}
        buttonProps={buttonProps}
        buttonChildren={buttonChildren}
      />
      <CreateAmendmentModal
        modalDialog={modalDialog}
        methods={methods}
        handleClose={handleClose}
        getFormStep={getFormStep}
        primaryButton={primaryButton}
        tertiaryButton={tertiaryButton}
      />
      {confirmationPrompt}
    </>
  );
}

export default CreateAmendment;
